import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { Row, Form, Checkbox, Input } from 'antd';
import { connect } from 'react-redux';

// Components
import Api_tnn from '../../../api/api.tnn';
import Message from '../../Messages';
import Table from '../../Table';
import InputNumber from '../../Common/NumberField';
import Constant from '../../../constants/constant';
import Select from '../../Common/Select';
import message from '../../../components/Messages';
import { isNil, set } from 'lodash';
import RowTools from '../../Table/RowTools';
// import Input from "../../Common/Input"

// Columns
const columnDetail = ({} = {}) => [
  {
    title: '#',
    dataIndex: 'stt',
    width: '65px',
  },
  {
    title: 'Quan trắc tự động',
    dataIndex: 'qT_TuDong',
    width: 100,
    render: (value, row) => (
      <div style={{ textAlign: 'center' }}>
        <Checkbox defaultChecked={row.qT_TuDong} disabled={true} />
      </div>
    ),
  },
  {
    title: 'Thông số',
    dataIndex: 'tenThongSo',
  },
  {
    title: 'Đơn vị',
    dataIndex: 'tenDonVi',
    width: 150,
  },
  {
    title: 'Gía trị giới hạn nhỏ nhất',
    dataIndex: 'gioiHanMin',
    width: 120,
    render: (value, row) => <div>{value ? value : 0}</div>,
  },
  {
    title: 'Gía trị giới hạn lớn nhất',
    dataIndex: 'gioiHanMax',
    width: 120,
    render: (value, row) => <div>{value ? value : 0}</div>,
  },
];
const column = ({ dataDVD, setState } = {}) => [
  {
    title: '#',
    dataIndex: 'stt',
    width: '65px',
  },
  {
    title: 'Quan trắc tự động',
    dataIndex: 'qT_TuDong',
    width: 100,
    render: (value, row) => (
      <div style={{ textAlign: 'center' }}>
        <Checkbox
          defaultChecked={row.qT_TuDong}
          onChange={(value) => {
            row.qT_TuDong = value.target.checked;
          }}
        />
      </div>
    ),
  },
  {
    title: 'Thông số',
    dataIndex: 'tenThongSo',
    render: (value, row) => (
      <div>
        {row.tenThongSo === '' ? (
          <Input
            mandatory={false}
            width="100%"
            defaultValue={row.tenThongSo}
            onChange={(value) => {
              row.tenThongSo = value.target.value;
              row.kyHieuThongSo = value.target.value;
            }}
            style={{ border: '#fff' }}
          />
        ) : (
          <div>{row.tenThongSo}</div>
        )}
      </div>
    ),
  },
  {
    title: 'Đơn vị đo',
    dataIndex: 'tenDonVi',
    width: 150,
    render: (value, row, index) => (
      <div>
        <Select
          mandatory={false}
          onChange={(value, name) => {
            console.log(value, name.props.children);

            setState((prevState) => {
              const newList = [...prevState.dataSource];
              const updatedRow = {
                ...newList[index],
                idDonVi: value,
                tenDonVi: name.props.children,
              };
              newList[index] = updatedRow;
              return { dataSource: newList };
            });
          }}
          dataSource={dataDVD}
          width="100%"
          name="ten"
          name_value="id"
          // defaultValue={value ? value : undefined}
          value={value || null}
          error={row.hasError && !value}
        />
      </div>
    ),
  },
  {
    title: 'Giá trị giới hạn nhỏ nhất',
    dataIndex: 'gioiHanMin',
    width: 120,
    render: (value, row, index) => (
      <div>
        <InputNumber
          mandatory={false}
          width="100%"
          // defaultValue={row.gioiHanMin ? row.gioiHanMin : 0}
          value={value ?? null}
          onChange={(value) => {
            setState((prevState) => {
              const newList = [...prevState.dataSource];
              const updatedRow = {
                ...newList[index],
                gioiHanMin: value,
                hasError: false,
              };
              newList[index] = updatedRow;
              return { dataSource: newList };
            });
          }}
          error={row.hasError && isNil(value)}
        />
      </div>
    ),
  },
  {
    title: 'Giá trị giới hạn lớn nhất',
    dataIndex: 'gioiHanMax',
    width: 120,
    render: (value, row, index) => (
      <div>
        <InputNumber
          mandatory={false}
          width="100%"
          // defaultValue={row.gioiHanMax ? row.gioiHanMax : 0}
          value={value ?? null}
          onChange={(value) => {
            setState((prevState) => {
              const newList = [...prevState.dataSource];
              const updatedRow = {
                ...newList[index],
                gioiHanMax: value,
                hasError: false,
              };
              newList[index] = updatedRow;
              return { dataSource: newList };
            });
          }}
          error={row.hasError && isNil(value)}
        />
      </div>
    ),
  },
  {
    key: 'tools',
    title: 'Thao tác',
    dataIndex: 'id',
    align: 'center',
    fixed: 'right',
    width: '80px',
    render: (value, row, index) => (
      <div>
        <RowTools
          row={row}
          deleteRowModal={() => {
            setState((prevState) => {
              const newList = [...prevState.dataSource];
              const updatedList = newList
                .filter((item, idx) => idx !== index)
                .map((item, index) => ({
                  ...item,
                  stt: index + 1,
                }));

              return { dataSource: updatedList };
            });
          }}
          iconEdit={true}
        />
      </div>
    ),
    isNotExportExcel: true,
  },
];

class GioiHanThongSo extends React.Component {
  constructor() {
    super();
    this.state = {
      dataSource: [],
      dataDVD: [],
      key: 0,
    };
  }

  componentDidMount() {
    this.get_CauHinhThongSo();
    this.GetApiQT_DonViDos();
  }

  getDataSource = () => {
    const { dataSource } = this.state;

    let listThongSoError = false;
    const newListThongSo = dataSource?.map((thongSo) => {
      const hasError =
        thongSo?.qT_TuDong &&
        (isNil(thongSo?.gioiHanMin) ||
          isNil(thongSo?.gioiHanMax) ||
          isNil(thongSo?.idDonVi) ||
          isNil(thongSo?.tenDonVi));
      if (hasError) listThongSoError = true;
      return {
        ...thongSo,
        hasError: hasError,
      };
    });

    if (listThongSoError) {
      this.setState({ dataSource: newListThongSo });
      Message.warning(
        'Thông số được chọn phải có đủ đơn vị, giới hạn nhỏ nhất và lớn nhất.'
      );
      return;
    }

    return this.state.dataSource;
  };
  GetApiQT_DonViDos = () => {
    new Api_tnn()
      .GetQT_DonViDos({
        token: this.props.user.access_token,
        page: 0,
        size: 0,
      })
      .then((res) => {
        this.setState({
          dataDVD: res.data,
        });
      })
      .catch((err) => {
        message.error(err.message);
      });
  };

  get_CauHinhThongSo = ({
    isNhomCongTrinhNuocMat,
    isLoaiCongTrinhThuyDien,
    isLoaiCongTrinhHoChua,
    thuyDien_LuuLuongXaDongChayToiThieu,
    thuyDien_LuuLuongLonNhatQuaNMTD,
    hoChua_LuuLuongXaDongChayMin,
  } = {}) => {
    const { user, quyChuanApDung } = this.props;
    if (quyChuanApDung) {
      new Api_tnn()
        .get_CauHinhThongSo_Init({
          token: user.access_token,
          id_qcvn: quyChuanApDung,
        })
        .then((res) => {
          this.setState({
            dataSource:
              res.list_gioihan_thongso &&
              res.list_gioihan_thongso.map((item, index) => {
                let gioiHanMin = item.gioiHanMin || null;
                let gioiHanMax = item.gioiHanMax || null;
                if (
                  item.idThongSo === 154 &&
                  isNhomCongTrinhNuocMat &&
                  isLoaiCongTrinhThuyDien &&
                  thuyDien_LuuLuongXaDongChayToiThieu
                ) {
                  gioiHanMin = thuyDien_LuuLuongXaDongChayToiThieu;
                }

                if (
                  item.idThongSo === 155 &&
                  isNhomCongTrinhNuocMat &&
                  isLoaiCongTrinhThuyDien &&
                  thuyDien_LuuLuongLonNhatQuaNMTD
                ) {
                  gioiHanMax = thuyDien_LuuLuongLonNhatQuaNMTD;
                }

                if (
                  item.idThongSo === 154 &&
                  isNhomCongTrinhNuocMat &&
                  isLoaiCongTrinhHoChua &&
                  hoChua_LuuLuongXaDongChayMin
                ) {
                  gioiHanMin = hoChua_LuuLuongXaDongChayMin;
                }

                return {
                  ...item,
                  stt: index + 1,
                  gioiHanMin: gioiHanMin,
                  gioiHanMax: gioiHanMax,
                };
              }),
          });
        })
        .catch((err) => Message.error(err.message));
    } else {
      this.setState({ dataSource: [] });
    }
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { initialValue, quyChuanApDung, mode, dataCT } = this.props;
    const { dataSource } = this.state;

    const isNhomCongTrinhNuocMat =
      dataCT?.data?.nhomCongTrinh === Constant.DICT_NHOM_CT.NM;
    const isLoaiCongTrinhThuyDien =
      dataCT?.data?.loaiCongTrinh === Constant.DICT_LOAI_CT.NM_THUYDIEN;
    const isLoaiCongTrinhHoChua =
      dataCT?.data?.loaiCongTrinh === Constant.DICT_LOAI_CT.NM_HOCHUA;
    const thuyDien_LuuLuongXaDongChayToiThieu =
      dataCT?.data?.luuLuongXaDongChayToiThieu;
    const thuyDien_LuuLuongLonNhatQuaNMTD =
      dataCT?.data?.luuLuongLonNhatQuaNMTD;
    const hoChua_LuuLuongXaDongChayMin = dataCT?.data?.luuLuongXaDongChayMin;

    if (
      prevProps.initialValue !== initialValue &&
      initialValue &&
      initialValue.length > 0
    ) {
      // data giới hạn thông số thay đổi
      mode === 'presentation'
        ? this.setState({
            dataSource: initialValue
              .filter((value) => value.tenThongSo !== '')
              .map((item, index) => ({ ...item, stt: index + 1 })),
          })
        : this.setState({
            dataSource: initialValue.map((item, index) => ({
              ...item,
              stt: index + 1,
            })),
          });
    } else if (prevProps.quyChuanApDung !== quyChuanApDung) {
      // Quy chuẩn áp dụng thay đổi
      this.get_CauHinhThongSo({
        isNhomCongTrinhNuocMat,
        isLoaiCongTrinhThuyDien,
        isLoaiCongTrinhHoChua,
        thuyDien_LuuLuongXaDongChayToiThieu,
        thuyDien_LuuLuongLonNhatQuaNMTD,
        hoChua_LuuLuongXaDongChayMin,
      });
    }

    if (prevProps.dataCT !== dataCT) {
      // data công trình thay đổi
      if (
        isNhomCongTrinhNuocMat &&
        isLoaiCongTrinhThuyDien &&
        (thuyDien_LuuLuongXaDongChayToiThieu || thuyDien_LuuLuongLonNhatQuaNMTD)
      ) {
        this.setState({
          dataSource: dataSource.map((e, idx) => ({
            ...e,
            gioiHanMin:
              e.idThongSo === 154
                ? thuyDien_LuuLuongXaDongChayToiThieu
                : e.gioiHanMin,
            gioiHanMax:
              e.idThongSo === 155
                ? thuyDien_LuuLuongLonNhatQuaNMTD
                : e.gioiHanMax,
          })),
          key: Math.random(),
        });
      } else if (
        isNhomCongTrinhNuocMat &&
        isLoaiCongTrinhHoChua &&
        hoChua_LuuLuongXaDongChayMin
      )
        this.setState({
          dataSource: dataSource.map((e, idx) => ({
            ...e,
            gioiHanMin:
              e.idThongSo === 154 ? hoChua_LuuLuongXaDongChayMin : e.gioiHanMin,
            gioiHanMax: e.idThongSo === 155 ? null : e.gioiHanMax,
          })),
          key: Math.random(),
        });
    }
  }

  render() {
    const { mode } = this.props;
    const { dataSource, dataDVD, key } = this.state;
    return (
      <Row>
        <Table
          columns={
            mode !== 'presentation'
              ? column({ dataDVD, setState: this.setState.bind(this) })
              : columnDetail({})
          }
          dataSource={dataSource}
          pagination={false}
          // scroll={{ y: 400 }}
          key={key}
        />
      </Row>
    );
  }
}

GioiHanThongSo.propTypes = {
  initialValue: PropTypes.object,
  mode: PropTypes.string.isRequired,
  quyChuanApDung: PropTypes.number.isRequired,
};

const mapStateToProps = (state) => ({
  user: state.oidc.user,
});

export default connect(mapStateToProps, null, null, { forwardRef: true })(
  GioiHanThongSo
);
